import React from 'react';
import { BackdropStyle, CloseButton } from './Backdrop.styled';
import CloseWhite from 'src/assets/images/CloseWhite.svg';

const Backdrop = (props) => {
    return (
        <BackdropStyle
            show={props.showBackdrop}
            loaderBackground={props.loaderBackground}
        >
            <CloseButton onClick={props.closeBackdrop} isModal={props.isModal}>
                <div
                    style={{
                        // border: '1px dashed #ffffff',
                        // background: '#b9a4a445',
                        position: 'absolute',
                        height: '44px',
                    }}
                >
                    <img
                        src={CloseWhite}
                        alt="CloseButton"
                        style={{ margin: '50px 8px 8px', width: '1.38rem'}}
                        width="auto"
                        height="auto"
                    />
                </div>
            </CloseButton>
            {props.children}
        </BackdropStyle>
    );
};

Backdrop.defaultProps = {
    showCloseButton: true,
};

export default Backdrop;
